import React, { useState } from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import Parallax from "components/Parallax/Parallax";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { TextField, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function RequestAccountDeletion(props) {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const classes = useStyles();
    const settings = useSelector(state => state.settingsdata.settings);
    const { ...rest } = props;

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError("Por favor, preencha todos os campos.");
            return;
        }
        else {
            setError(undefined);
        }

        alert("Solicitação de exclusão de conta realizada com sucesso!");


        navigate('/');
    };

    return (
        <div style={{ margin: '-8px' }}>
            <Header
                color="transparent"
                routes={dashboardRoutes}
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 400,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/header-back.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <Typography color={'black'} variant="h4" textAlign={'center'} gutterBottom style={{ paddingTop: "2rem", paddingBottom: "1rem", }}>
                        Solicitação de Exclusão de Conta
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <Container maxWidth="xs">
                            <TextField
                                label="E-mail"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                            />
                            <TextField
                                label="Senha"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                            />
                            {error && <Typography color="error" variant="body2">{error}</Typography>}
                            <Button
                                variant="contained"
                                color="secondary"
                                type="submit"
                                fullWidth
                                style={{ marginTop: "20px" }}
                            >
                                Solicitar Exclusão
                            </Button>
                        </Container>
                    </form>
                    <Typography color={'black'} variant="body1" align="center" style={{ paddingTop: "1rem", paddingBottom: "2rem", }}>
                        Ao solicitar a exclusão de sua conta, todos os dados relacionados a você serão excluídos permanentemente, de acordo com nossa política de privacidade.
                    </Typography>
                </div>
            </div>
            <Footer />
        </div>
    );
}